export default __webpack_public_path__ + "static/media/video1.5aabfc6c.mp4";